(function() {
  var forms = document.querySelectorAll('[data-predictive-search-form]');

  function searchAlias(term) {
    var normalized = term.toLowerCase().replace(/[^a-z0-9]/g, '');

    if (normalized === 'needoh') {
      return {
        suggestionsUrl: '/collections/sensory?sort_by=best-selling&section_id=needoh-search',
        destinationUrl: '/collections/sensory?sort_by=best-selling'
      };
    }

    return null;
  }

  Array.prototype.forEach.call(forms, function(form) {
    var input = form.querySelector('[data-predictive-search-input]');
    var results = form.querySelector('[data-predictive-search-results]');
    var timer;
    var controller;

    if (!input || !results) return;

    function closeResults() {
      results.hidden = true;
      results.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
    }

    function requestResults() {
      var term = input.value.trim();
      var alias = searchAlias(term);

      if (term.length < 2) {
        closeResults();
        return;
      }

      if (controller) controller.abort();
      controller = window.AbortController ? new AbortController() : null;

      var url = alias ? alias.suggestionsUrl :
        '/search/suggest?q=' + encodeURIComponent(term) +
          '&resources[type]=product,collection,query' +
          '&resources[limit]=8' +
          '&resources[options][unavailable_products]=last' +
          '&section_id=predictive-search';

      fetch(url, controller ? { signal: controller.signal } : {})
        .then(function(response) {
          if (!response.ok) throw new Error('Predictive search request failed');
          return response.text();
        })
        .then(function(html) {
          results.innerHTML = html;
          results.hidden = false;
          input.setAttribute('aria-expanded', 'true');
        })
        .catch(function(error) {
          if (error.name !== 'AbortError') closeResults();
        });
    }

    input.addEventListener('input', function() {
      window.clearTimeout(timer);
      timer = window.setTimeout(requestResults, 180);
    });

    input.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') {
        closeResults();
        return;
      }

      if (event.key === 'Enter') {
        var alias = searchAlias(input.value.trim());
        if (!alias) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        window.location.href = window.location.origin + alias.destinationUrl;
      }
    }, true);

    form.addEventListener('submit', function(event) {
      var alias = searchAlias(input.value.trim());
      if (!alias) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign(alias.destinationUrl);
    }, true);

    document.addEventListener('click', function(event) {
      if (!form.contains(event.target)) closeResults();
    });
  });
})();
